import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService, manageFilters } from '@app/services';
import { IActiveFilter } from '@app/models';

class ScheduledJobsService {
    readonly apiBase: string = '/api/directory/Jobs';

    getScheduledJobs(orderBy: string, asc: string, top: number, skip: number, isReset: boolean, handleSuccess: Function,
        handleError: Function, filters?: IActiveFilter[]): AxiosPromise {

        return apiService.get(`${this.apiBase}?$expand=Triggers`, {
            params: {
                $orderBy: orderBy + ' ' + asc,
                $top: top,
                $skip: skip,
                $count: isReset,
                ...(filters ? { $filter: manageFilters(filters) } : { $filter: manageFilters([]) })
            },
            onError: handleError, onSuccess: handleSuccess
        })
            .catch();
    }

    getScheduledJob(id: string, group: string, scheduler: string, handleSuccess: Function,
        handleError: Function): AxiosPromise {

        return apiService.get(`${this.apiBase}('${id}', '${group}', '${scheduler}')?$expand=Triggers`, {
            onError: handleError, onSuccess: handleSuccess
        })
            .catch();
    }

    triggerJob(jsonObject: any, handleSuccess: Function, handleError: Function): AxiosPromise {

        return apiService.post(this.apiBase + '/Trigger',
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }
}

export const scheduledJobsService = new ScheduledJobsService();